export const ninmtFileTypes = ['painAndSymptomMap'];
